import { lazy, Suspense } from 'react';
import NoSelection from 'shared/components/avatar/NoSelection';
import { HairBaseColors, HairHighlightColors } from 'shared/types/colorSets';
import { FacialHairBehindMouthList, FacialHairMultiColorList, FacialHairNoColorList } from 'shared/types/optionSets';
import { getHighlightColor } from '../utils/HighlightColors';
import { DEFAULT_THUMBNAIL_STYLE, FACIAL_HAIR_Z_INDEX, getAvatarViewLayerStyle, MOUTH_Z_INDEX, STANDARD_LAYER_VIEWBOX } from '../utils/LayoutUtils';

interface Props {
  option: number;
  colorBase: string;
  isThumbnail?: boolean;
}

const THUMBNAIL_VIEWBOX = "300 400 500 500";

const FacialHairLayer = ({ option, colorBase, isThumbnail }: Props) => {
  const viewBox = isThumbnail ? THUMBNAIL_VIEWBOX : STANDARD_LAYER_VIEWBOX;

  const zIndex = FacialHairBehindMouthList.includes(option) ? MOUTH_Z_INDEX - 1 : FACIAL_HAIR_Z_INDEX;
  const style = isThumbnail ? DEFAULT_THUMBNAIL_STYLE : getAvatarViewLayerStyle(zIndex);

  const componentName = option < 10 ? `FacialHair0${option}` : `FacialHair${option}`;
  const FacialHairComponent = lazy(() => import(`shared/components/avatar/facialhair/${componentName}`));

  const getFacialHairHighlight = () => {
    return getHighlightColor(colorBase, HairBaseColors, HairHighlightColors);
  };

  if (option === 0) {
    if (isThumbnail) {
      return (
        <NoSelection />
      );
    }
    return null;
  }

  if (FacialHairNoColorList.includes(option)) {
    return (
      <Suspense fallback={<div />}>
        <FacialHairComponent
          viewBoxProp={viewBox}
          style={style}
        />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<div />}>
      {FacialHairMultiColorList.includes(option) ? (
        <FacialHairComponent
          viewBoxProp={viewBox}
          colorBase={colorBase}
          colorHighlight={getFacialHairHighlight()}
          style={style}
        />
      ) : (
        <FacialHairComponent
          viewBoxProp={viewBox}
          colorBase={colorBase}
          style={style}
        />
      )}
    </Suspense>
  );
}

export default FacialHairLayer;
